import React, { useState, useEffect } from 'react';
import LeagueTable from './components/LeagueTable'; // Assuming the component file is named LeagueTable.js

const App = () => {
  const [matchData, setTableData] = useState([]);
  const [error, setError] = useState(null);
  const queryParams = new URLSearchParams(window.location.search);
  const leagueId = queryParams.get('league_id'); // Get the league ID from URL

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(
          `https://stats.leaguemaster.de/games?league_id=${leagueId}&order_desc=true`,
          {
            method: 'GET',
            headers: {
              Accept: 'application/json',
            },
          }
        );

        if (response.ok) {
          const data = await response.json();
          setTableData(data); // Set the fetched data to state
        } else {
          throw new Error('Failed to fetch data');
        }
      } catch (error) {
        console.error('Error fetching data:', error);
        setError('Failed to fetch lacrosse standings. Please try again later.'); // Set error state
      }
    };
    if (leagueId) {
      fetchData();
    } else {
      setError('League ID not provided');
    }
  }, [leagueId]);

  return (
    <div className="App">
      {error ? (
        <p>{error}</p>
      ) : (
        <LeagueTable matches={matchData} />
      )}
    </div>
  );
};
export default App;